export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("app:error", (error) => {
    const reloadErrorList = [
      "Error loading dynamically imported module",
      "Importing a module script failed",
      "Failed to fetch dynamically imported module",
    ];

    if (reloadErrorList.some((e) => error.message.includes(e))) {
      reloadNuxtApp();
    } else {
    }
  });
});
